import { Decimal } from './decimal.js';
import { money, type Money } from './money.js';
import type { Currency } from '../types/enums.js';

/**
 * A multi-currency total that has not been converted yet.
 *
 * Fees, dividends and taxes routinely arrive in a different currency than the
 * trades (a USD stock paying a EUR dividend), and converting them at ingest
 * time would bake in a rate the user cannot later change. So they accumulate
 * per currency and are converted only for display.
 */
export type MoneyBag = ReadonlyMap<Currency, Decimal>;

export function emptyBag(): Map<Currency, Decimal> {
  return new Map();
}

export function addToBag(bag: Map<Currency, Decimal>, value: Money): Map<Currency, Decimal> {
  const current = bag.get(value.currency) ?? new Decimal(0);
  bag.set(value.currency, current.plus(value.amount));
  return bag;
}

export function bagEntries(bag: MoneyBag): Money[] {
  return [...bag.entries()]
    .filter(([, amount]) => !amount.isZero())
    .map(([currency, amount]) => money(amount, currency));
}

export function isBagEmpty(bag: MoneyBag): boolean {
  for (const amount of bag.values()) {
    if (!amount.isZero()) return false;
  }
  return true;
}
